import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FloatingMenu from "../FloatingMenu/FloatingMenu";
import { NotificationProvider } from "../../../contexts/NotificationContext";

const DefaultLayout = ({ children }) => {
  return (
    <>
      <NotificationProvider>
        <Header />
      </NotificationProvider>
      <FloatingMenu />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default DefaultLayout;
